import React from "react";

const HelpManual = () => {
  return (
    <div className="contentarea pt-5">
      <div className="sliderInrHdng" style={{ position:"static" }}>
        <h2>Help<span className="hdngBrkr">Manual</span></h2>
        </div>
      <ul className="d-flex justify-content-center gap-4 pdfBOx">
        <li>
          <a
            href="https://aictevoicestaanuvadini.blob.core.windows.net/ecoclubs/Hindi_DoSEL_Eco_Clubs_Mission_LiFE_Manual-2.hi.pdf?sp=r&st=2026-02-06T06:00:58Z&se=2026-12-31T14:15:58Z&spr=https&sv=2024-11-04&sr=c&sig=n4zcC%2FICuzy6IgQ62mGtREv%2FQI3HUeu2TFULEdZkDyI%3D"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "underline" }}
          >
            Help Manual (Hindi)
          </a>
        </li>
        <li>
          <a
            href="https://aictevoicestaanuvadini.blob.core.windows.net/ecoclubs/DoSEL_Eco_Clubs_Mission_LiFE_Manual-2.pdf?sp=r&st=2026-02-06T06:00:58Z&se=2026-12-31T14:15:58Z&spr=https&sv=2024-11-04&sr=c&sig=n4zcC%2FICuzy6IgQ62mGtREv%2FQI3HUeu2TFULEdZkDyI%3D"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "underline" }}
          >
            Help Manual (English)
          </a>
        </li>
      </ul>

    </div>
  );
};

export default HelpManual;
